import React, { useEffect, useState } from 'react';
import DatePicker from '../../atoms/DatePicker/DatePicker';
import Select from '../../atoms/Select';
import TextInput from '../../atoms/TextInput';
import moment from 'moment';
import 'moment-timezone';
import { numbersAndLettersMask, plateMask } from '../../../utils/masks';
import { JSDateHolidays } from '@/utils/feriados';
import { INDISPONIBILIDADE_2025 } from '@/utils/datas';

const times = [
  {
    value: '',
    text: 'Período',
    disabled: true,
  },
  {
    text: 'Manhã',
    value: '08:00',
  },
  {
    text: 'Tarde',
    value: '13:00',
  },
];

const PeriodsEnum = {
  TODOS: 0,
  MANHA: 1,
  TARDE: 2,
};

export const VehicleType = {
  NOVO: 'Novo',
  USADO: 'Usado',
};

function Step3({ handleChange, handleBlur, values, setFieldValue, touched, errors, setTouched }) {
  const [timeOptions, setTimeOptions] = useState(times);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setmaxDate] = useState(moment().add(12, 'month').toDate());

  const updateTimePicker = (opt) => {
    switch (opt) {
      case PeriodsEnum.MANHA:
        setTimeOptions([times[0], times[1]]);
        break;

      case PeriodsEnum.TARDE:
        setTimeOptions([times[0], times[2]]);
        break;

      default:
        setTimeOptions(times);
        break;
    }
  };

  const pickedThisMoment = (mom1, mom2) => {
    return (
      mom1.get('year') === mom2.get('year') &&
      mom1.get('date') === mom2.get('date') &&
      mom1.get('month') === mom2.get('month')
    );
  };

  const handlePickedDate = (pickedDate) => {
    const today = moment.tz(new Date(), 'America/Sao_Paulo');
    const todayHours = today.get('hours');
    const todayDay = today.get('day');

    if (pickedDate) {
      const pickedMoment = moment.tz(pickedDate, 'America/Sao_Paulo');
      // Sábado apenas manhâ
      if (pickedMoment.get('d') === 6) {
        updateTimePicker(PeriodsEnum.MANHA);
        return;
      }
    }

    // Sábado/Domingo: solicitações feitas nos sábados ou domingos
    // trazer apenas a opção de agendamento para próximo segunda no período da tarde;
    if ([0, 6].includes(todayDay)) {
      // console.log('HOJE É SABADO OU DOMINGO');
      const addedDays = todayDay === 0 ? 1 : 2;
      const min = today.clone().add(addedDays, 'days');
      setMinDate(min.toDate());

      if (pickedDate) {
        const pickedMoment = moment.tz(pickedDate, 'America/Sao_Paulo');
        if (pickedThisMoment(min, pickedMoment)) {
          updateTimePicker(PeriodsEnum.TARDE);
          return;
        }
      }

      updateTimePicker(PeriodsEnum.TODOS);
      return;
    }

    // Sábado trabalharemos apenas com agendamento solicitados até sexta as 14:00,
    // e instalações aos sábados somente para o período da manhã.
    if (todayDay === 5 && todayHours >= 14) {
      // console.log('HOJE É SEXTA DEPOIS DAS 14');
      const min = today.clone().add(3, 'days');
      setMinDate(min.toDate());

      if (pickedDate) {
        const pickedMoment = moment.tz(pickedDate, 'America/Sao_Paulo');
        if (pickedThisMoment(min, pickedMoment)) {
          updateTimePicker(PeriodsEnum.TARDE);
          return;
        }
      }

      updateTimePicker(PeriodsEnum.TODOS);
      return;
    }

    // Manhã: solicitações até as 10hs, trazer apenas opção de “tarde” ou “próximo dia”,
    // exceto domingo que não temos instalação, e sábado seguindo a regra;
    if (todayHours < 10) {
      // console.log('HOJE ATÉ AS 10');
      const min = today.clone();
      setMinDate(min.toDate());

      if (pickedDate) {
        const pickedMoment = moment.tz(pickedDate, 'America/Sao_Paulo');
        if (pickedThisMoment(min, pickedMoment)) {
          updateTimePicker(PeriodsEnum.TARDE);
          return;
        }
      }

      updateTimePicker(PeriodsEnum.TODOS);
      return;
    }

    // Tarde: solicitações das 10hs às 14hs, trazer apenas opção de “próximo dia” período de manhã e tarde,
    // exceto domingo/feriado que não temos instalação, e sábado seguindo a regra;
    if (todayHours >= 10 && todayHours < 14) {
      // console.log('HOJE DAS 10 AS 14');
      setMinDate(today.clone().add(1, 'day').toDate());
      updateTimePicker(PeriodsEnum.TODOS);
      return;
    }

    // Tarde: solicitações após as 14hs, trazer apenas opção de “próximo dia” período da tarde,
    // exceto domingo/feriado que não temos instalação, e sábado seguindo a regra;
    if (todayHours >= 14) {
      // console.log('HOJE APÓS 14');
      const min = today.clone().add(1, 'day');
      const newMinDate = min.toDate();
      setMinDate(newMinDate);

      if (pickedDate) {
        const pickedMoment = moment.tz(pickedDate, 'America/Sao_Paulo');
        if (pickedThisMoment(min, pickedMoment)) {
          updateTimePicker(PeriodsEnum.TARDE);
          return;
        }

        const diff = pickedMoment.diff(min, 'days', true);
        if (diff >= 2) {
          updateTimePicker(PeriodsEnum.TODOS);
          return;
        }
      }

      updateTimePicker(PeriodsEnum.TARDE);
      return;
    }
  };

  useEffect(() => {
    handlePickedDate(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFieldValue('installTime', '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeOptions]);

  return (
    <>
      <h4>Dados do veículo</h4>
      <Select
        placeholder="Veículo"
        name="vehicleType"
        onChange={(ev) => {
          setTouched({ vehiclePlate: false }, false);
          handleChange(ev);
        }}
        value={values.vehicleType}
        options={[
          {
            text: 'Veículo',
            value: '',
            disabled: true,
          },
          {
            text: 'Novo',
            value: VehicleType.NOVO,
          },
          {
            text: 'Usado',
            value: VehicleType.USADO,
          },
        ]}
        onBlur={handleBlur}
        completed={touched.vehicleType && !errors.vehicleType}
        error={touched.vehicleType && errors.vehicleType}
      />
      <TextInput
        placeholder="Modelo"
        name="vehicleModel"
        onChange={handleChange}
        value={values.vehicleModel}
        maxLength={100}
        onBlur={handleBlur}
        completed={touched.vehicleModel && !errors.vehicleModel}
        error={touched.vehicleModel && errors.vehicleModel}
      />
      <TextInput
        placeholder="Chassi"
        name="vehicleChassi"
        onChange={handleChange}
        value={values.vehicleChassi}
        maxLength={17}
        onBlur={handleBlur}
        completed={touched.vehicleChassi && !errors.vehicleChassi}
        error={touched.vehicleChassi && errors.vehicleChassi}
      />
      <TextInput
        placeholder="Redigitar Chassi"
        name="vehicleChassi2"
        onChange={handleChange}
        value={values.vehicleChassi2}
        maxLength={17}
        onBlur={handleBlur}
        completed={touched.vehicleChassi2 && !errors.vehicleChassi2}
        error={touched.vehicleChassi2 && errors.vehicleChassi2}
        onPaste={(ev) => {
          ev.preventDefault();
          return false;
        }}
        onDrop={(ev) => {
          ev.preventDefault();
          return false;
        }}
      />
      {values.vehicleType === VehicleType.USADO && (
        <TextInput
          placeholder="Placa"
          name="vehiclePlate"
          maxLength={7}
          onChange={(ev) => {
            ev.target.value = numbersAndLettersMask(ev.target.value);
            handleChange(ev);
          }}
          value={values.vehiclePlate}
          onBlur={handleBlur}
          completed={touched.vehiclePlate && !errors.vehiclePlate}
          error={touched.vehiclePlate && errors.vehiclePlate}
        />
      )}
      <h4>Dados de intenção de instalação*</h4>

      <DatePicker
        placeholder="Data"
        value={values.installDate}
        onChange={(date) => {
          handlePickedDate(date);
          setFieldValue('installDate', date);
        }}
        datePickerProps={{
          minDate,
          maxDate,
          excludeDates: JSDateHolidays.concat(INDISPONIBILIDADE_2025),
          filterDate: (date) => {
            const day = date.getDay();

            // Domingo: não permite escolhas de instalação aos domingos e feriados,
            // apenas para próximo dia útil período da tarde.
            return day !== 0;
          },
        }}
        error={touched.installDate && errors.installDate}
      />

      <Select
        placeholder="Período"
        name="installTime"
        onChange={handleChange}
        value={values.installTime}
        options={timeOptions}
        onBlur={handleBlur}
        completed={touched.installTime && !errors.installTime}
        error={touched.installTime && errors.installTime}
      />
    </>
  );
}

export default Step3;
